import { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { useOutletContext } from "react-router-dom";
import { currency_converter_inr } from "../../../utils/currencyUtils";
import { openInAppTab } from "../../../utils/tabNavigation";

function WorkAllocation(){
  const { selectedUser, year, setGlobalLoading, token } = useOutletContext();
  const [data,setData] = useState([]);
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const currentWeek = data?.currentWeek || 30;
  const visibleWeeks = 12;
  const [startWeek, setStartWeek] = useState( Math.max(1, currentWeek - visibleWeeks + 1));
//   const [endWeek, setEndWeek] = useState( startWeek + visibleWeeks - 1);
  const weeks = Array.from({ length: visibleWeeks }, (_, i) => startWeek + i).filter(w => w <= currentWeek);
  const [viewType, setViewType] = useState("team"); // team | role
  const [teamSummary, setTeamSummary] = useState({});
  const [showClosedRoleModal, setShowClosedRoleModal] = useState(false);
  const [closedRoles, setClosedRoles] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [abRoles, setAbRoles] = useState([]);
  const [showAbRoleModal, setShowAbRoleModal] = useState(false);

  const getCurrentFY = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // Jan = 1

    // If before April → still previous FY
    if (month < 4) {
        return `${year - 1} - ${year}`;
    } else {
        return `${year} - ${year + 1}`;
    }
    };

    function RevenueCounter({ value, format = true }) {
        const safeValue = Number(value) || 0;
        return (
            <CountUp
                start={0}
                end={safeValue}
                duration={1}
                formattingFn={format ? currency_converter_inr : undefined}
            />
        );
    }

  useEffect(()=>{
    if(!selectedUser) return;
    let isLatest = true; 
    const workAllocation = async ()=>{
    try{
    setGlobalLoading(true);    
    
    const response = await axios.get(`${REACT_APP_API_BASE_URL}/performance/work_allocation`,
     {
        params:{ user_id:selectedUser.id, year:year, mode:viewType },
        headers: { Authorization: `Bearer ${token}` },
     }
    );
     if (!isLatest) return;
    const d = response.data;
    console.log("Work Allocation response", response.data);
    setTeamSummary(d.teamSummary);
    if(response.status === 200) {
        setData({
          ...d,
          active_role: d.active_role
        });
        }
 
    }catch (error) {
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    };
    workAllocation();
     return () => {
        isLatest = false; // cancel old request
    };
    },[selectedUser,year,viewType]);

    const getVisibleRoles = (roles) => {
    const endWeek = startWeek + visibleWeeks - 1;

    return (roles || []).filter(
        (r) => r.end_week >= startWeek && r.start_week <= endWeek
    );
    };

    const getBarStyle = (role) => {
    const endWeek = startWeek + visibleWeeks - 1;

    const start = Math.max(role.start_week, startWeek);
    const end = Math.min(role.end_week, endWeek);

    return {
        gridColumn: `${start - startWeek + 1} / ${end - startWeek + 2}`,
    };
    };

    const getColor = (role) => {
    if (role.working_days >= role.tat) return "#ef4444";
    if (role.working_days >= role.tat * 0.8) return "#f59e0b";
    return "#10b981";
    };
    useEffect(() => {
        if (data?.currentWeek) {
            setStartWeek(Math.max(1, data.currentWeek - visibleWeeks + 1));
        }
    }, [data.currentWeek]);

    const uniqueActiveRoles = new Set();
    (data?.employees || []).forEach(emp => {
    (emp.roles || []).forEach(role => {
        uniqueActiveRoles.add(role.role_id);
    });
    });

    // const activeRoleCount = uniqueActiveRoles.size;

    const atRiskRoles = new Set();
    (data?.employees || []).forEach(emp => {
    (emp.roles || []).forEach(role => {
        if (Number(role.working_days) >= Number(role.tat)) {
        atRiskRoles.add(role.role_id);
        }
    });
    });
    const atRiskCount = atRiskRoles.size;
    // const getHiddenWeeks = (role) => {
    //     return Math.max(0, (startWeek - role.start_week) + (role.active_week > endWeek ? (role.active_week - endWeek) : 0));
    // };
  //  const otherRole = (activeRoleCount > data?.active_role)?(activeRoleCount - data?.active_role):'0';
//   const otherRole = Math.max(0,(teamSummary?.assigned_role || 0) -(teamSummary?.active_role || 0)); 
  const hideActiveRoleText = [11, 12, 14].includes(Number(selectedUser?.id));
  const openClosedRoles = async (emp) => {
        setSelectedEmployee(emp);
        const response = await axios.get(
            `${REACT_APP_API_BASE_URL}/performance/get_closed_roles`,
            {
                params: {user_id: emp.user_id, year: year},
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        setClosedRoles(response.data.closed_role_list || []);
        setShowClosedRoleModal(true);
    };

  const openAbRoles = async (emp) => {
        setSelectedEmployee(emp);
        try {
            const response = await axios.get(
                `${REACT_APP_API_BASE_URL}/performance/get_ab_roles`,
                {
                    params: {user_id: emp.user_id},
                    headers: {Authorization: `Bearer ${token}`}
                }
            );
            setAbRoles(response.data.ab_role_list || []);
            setShowAbRoleModal(true);
        } catch (error) {
            console.log(error);
            setAbRoles([]);
        }
    };   

  return (
    <>
    <div className="card">
        <div className="card-body">
            <div className="border-bottom mb-3 pb-3">
                <h4>Work Allocation</h4>
                <p className="text-muted fs-13 mb-1">Role timelines, resource loading & availability</p>
            </div>

          <div className="row">
            <div className="col-xxl-3 col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill">
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            <i className="fa fa-users me-2"></i>
                            Active Resources
                        </p>
                        <h3 className="counter">{Number(data?.team?.length || 0)}</h3>
                      </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-md-6 d-flex">
                <div className={`card flex-fill cursor-pointer ${viewType === "team" ? "border border-info shadow-sm" : ""}`} onClick={() => setViewType("team")}>
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            <i className="fa fa-calendar me-2"></i>
                            Active Assignments (By Team)
                        </p>
                        <h3 className="counter" style={{ color: "#06B4A0" }}>
                            {Number(teamSummary?.assigned_role || 0)}
                            {teamSummary?.assigned_role > 0 && (
                                <span className="fs-12 fw-medium text-gray-5 ms-1">roles assigned to the team</span>
                            )}
                            
                        </h3>
                        {!hideActiveRoleText && (
                            <div className="mt-1">
                                Out of your <b>{teamSummary?.active_role || 0}</b> Active Roles
                            </div>
                        )}
                        {/* {(teamSummary?.active_role - teamSummary?.assigned_role) > 0 && (
                            <span className="fs-12 fw-medium text-gray-5 ms-2">
                                ({teamSummary?.active_role - teamSummary?.assigned_role} allocated to others)<br />
                            </span>
                        )} */}
                        
                        {/* {otherRole > 0 && (
                                <span className="fs-12 fw-medium text-gray-5 ms-2">
                                    <br />({otherRole} from shared roles)
                                </span>
                            )}  */}
                      </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-md-6 d-flex">
                <div className={`card flex-fill cursor-pointer ${viewType === "role" ? "border border-info shadow-sm": ""}`} onClick={() => setViewType("role")}>
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            <i className="fa fa-calendar me-2"></i>
                            Active Assignments (By Your Role)
                        </p>
                        <h3 className="counter" style={{ color: "#06B4A0" }}>
                            {teamSummary?.active_role || 0}
                        </h3>
                      </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            {/* <div className="col-xxl-3 col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            <i className="fa fa-clock me-2"></i>
                            Avg Utilization
                        </p>
                        <h3 className="counter">79%</h3>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            
                        </p>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div> */}
            <div className="col-xxl-3 col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                <div className="card-body my-card-body">
                    <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <div>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            <i className="fa fa-exclamation-circle me-2"></i>
                            At Risk
                        </p>
                        <h3 className="counter">{Number(atRiskCount || 0)}</h3>
                        <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                            
                        </p>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
          </div>
            <Modal show={showClosedRoleModal} onHide={() => setShowClosedRoleModal(false)} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Closed Roles - {selectedEmployee?.employee}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <table className="table table-bordered table-sm">
                        <thead>
                            <tr>
                                <th>Role</th>
                                <th>Company</th>
                                <th>Candidate</th>
                                <th>TAT (Weeks)</th>
                                <th>Industry TAT (Weeks)</th>
                            </tr>
                        </thead>

                        <tbody>
                            {closedRoles.map(role => (
                                <tr key={role.id}>
                                    <td>{role.role_name}</td>
                                    <td>{role.company_name}</td>
                                    <td>{role.candidate_name}</td>
                                    <td>{role.tat_weeks}</td>
                                    <td>{role.industry_tat_weeks}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Modal.Body>
            </Modal>

            <Modal show={showAbRoleModal} onHide={() => setShowAbRoleModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        A&B Roles - {selectedEmployee?.employee}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <table className="table table-bordered table-sm">
                        <thead>
                            <tr>
                                <th>Role</th>
                                <th>Company</th>
                            </tr>
                        </thead>

                        <tbody>
                            {abRoles.length > 0 ? (
                                abRoles.map((role) => (
                                    <tr key={role.id}>
                                        <td>{role.role_name}</td>
                                        <td>{role.company_name}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center">
                                        No A&B roles found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </Modal.Body>
            </Modal>
            <div className="d-flex align-items-center flex-wrap row-gap-2 mb-2">
                    <i className="ti ti-globe fs-18 text-warning me-2"></i>
                    <h5>Timeline View</h5>
            </div>
            <div className="row">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <button className="btn btn-sm btn-light" disabled={startWeek === 1}
                                onClick={() => setStartWeek((s) => Math.max(1, s - 1))}
                            >
                                ◀ Previous
                            </button>
                            <button
                                className="btn btn-sm btn-light"
                                disabled={startWeek + visibleWeeks - 1 >= currentWeek}
                                onClick={() =>
                                    setStartWeek((s) =>
                                        Math.min(currentWeek - visibleWeeks + 1, s + 1)
                                    )
                                }
                            >
                                Next ▶
                            </button>

                        </div>

                        {/* Header */}
                        <div className="timeline-header"
                            style={{
                                display: "grid",
                                gridTemplateColumns: "250px repeat(12,1fr)",
                                marginBottom: 15,
                                fontWeight: 600,
                            }}
                        >
                            <div>Resource</div>
                            {weeks.map((week) => (
                                <div
                                    key={week}
                                    style={{
                                        textAlign: "center",
                                    }}
                                >
                                    W{week}
                                </div>
                            ))}
                        </div>
                        {/* Employees */}
                        {data?.employees?.map((emp) => (
                            <div
                                key={emp.user_id}
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "250px 1fr",
                                    marginBottom: 25,
                                }}
                            >
                                {/* Left */}

                                <div>
                                    <h6>{emp.employee}</h6>
                                    <div className="text-muted">
                                        {emp.designation}
                                    </div>
                                    <div className="badge bg-soft-secondary">{emp.utilization_status}</div>
                                     <div className="text-warning small">
                                        {emp.active_roles_all} Total Active {emp.active_roles_all > 1 ? "Roles" : "Role"}
                                    </div>
                                    <div className="text-info small">
                                        {emp.active_roles_selected} Active {emp.active_roles_selected > 1 ? "on your Roles" : "on your Role"}
                                    </div>
                                    <div className="text-purple small" style={{cursor: "pointer", textDecoration: "underline"}} onClick={() => openAbRoles(emp)}>
                                        {emp.ab_roles_selected} A&B Roles
                                    </div>
                                    <div className="text-primary small cursor-pointer" style={{ cursor: "pointer", textDecoration: "underline" }}
                                        onClick={() => openClosedRoles(emp)}
                                    >
                                        {emp.closed_roles} Closed {emp.closed_roles > 1 ? "Roles" : "Role"}
                                    </div>
                                </div>
                                {/* Timeline */}
                                <div
                                    style={{
                                        position: "relative",
                                        minHeight: Math.max(
                                            22,
                                            getVisibleRoles(emp.roles).length * 20
                                        ),
                                    }}
                                >
                                    {/* Week Lines */}
                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "repeat(12,1fr)",
                                            position: "absolute",
                                            inset: 0,
                                        }}
                                    >
                                        {weeks.map((w) => (
                                            <div
                                                key={w}
                                                style={{
                                                    borderLeft: "1px solid #eee",
                                                }}
                                            />
                                        ))}
                                    </div>

                                    {/* Bars */}

                                    {getVisibleRoles(emp.roles).map((role, i) => (
                                        <div
                                            key={role.role_id}
                                            style={{
                                                position: "absolute",
                                                top: i * 20,
                                                display: "grid",
                                                width: "100%",
                                                gridTemplateColumns: "repeat(12,1fr)",
                                                pointerEvents: "auto",
                                            }}
                                        >
                                           <div
                                                style={{
                                                    ...getBarStyle(role),
                                                    background: getColor(role),
                                                    color: "#fff",
                                                    height: 18,
                                                    borderRadius: 9,
                                                    position: "relative",
                                                    padding: "0 45px 0 8px", // reserve space on right
                                                    lineHeight: "18px",
                                                    overflow: "hidden",
                                                }}
                                            >
                                                <span>
                                                    <a
                                                    href={`/role/funnel/${role.role_id}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    title={`${role.role_name} (${role.company_name})`}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        openInAppTab(`/role/funnel/${role.role_id}`);
                                                    }}
                                                    style={{
                                                        color: "#fff",
                                                        textDecoration: "none",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        paddingRight: 40,
                                                        pointerEvents: "auto",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    {role.role_name}
                                                </a>
                                                </span>

                                                <span
                                                    style={{
                                                        position: "absolute",
                                                        right: 8,
                                                        top: 0,
                                                        lineHeight: "18px",
                                                        whiteSpace: "nowrap",
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    {role.active_week}W
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
   
    </>
   );
}

export default WorkAllocation
